"use client";
import dynamic from "next/dynamic";

import { SelectTheme } from "./SelectTheme";
import { StepProgressBar } from "./StepProgressBar";

const PackageContainer = dynamic(() =>
  import(`./PackageContainer`)
)
const Balance = dynamic(() =>
  import(`./Payment/Balance`))


export const CreateWesite = ({ name, lang ,data,default_currency,currency,searchParams}) => {
  
  const {step}=searchParams||{}
  let componentToRender;

  switch (true) {
    case step == "1":
      componentToRender = <SelectTheme  name={name} lang={lang} />;
      break;
    case step == "2":
      componentToRender = (
        <PackageContainer 
          inProgress={true} 
          data={data} 
          default_currency={default_currency} 
          site_name={name} 
          currency={currency} 
          lang={lang} 
        />
      );
      break;
    case step == "3":
      componentToRender = <Balance  data={data} name={name} />;
      break;
    default:
      componentToRender = <SelectTheme name={name} lang={lang} />;;
      break;
  }
  
  return (
    <>
      <StepProgressBar searchParams={searchParams} pageName="create_website" stepNumber={step} />
      {componentToRender}
    </>
  );
};
